import React, { Component } from 'react';
import Icons from '../../components/Icons';
import './Home.css';
import * as roles from './roles.json';

export default class Home extends Component {

  componentDidMount() {
    this.props.setPage("home");
  }

  render() {
    return (
      <div className="home">
        <h1>Who is Evan?</h1>
        <Icons source={roles} direction="right"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js